import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container header" }
const _hoisted_2 = {
  href: "",
  class: "header__logo"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "nav__list" }
const _hoisted_5 = {
  href: "",
  class: "nav__link"
}
const _hoisted_6 = {
  key: 0,
  class: "nav__item"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "nav__link"
}, " Контакты ", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "nav__item" }
const _hoisted_10 = {
  key: 0,
  class: "button header__enter"
}
const _hoisted_11 = {
  key: 0,
  class: "header__lang lang"
}
const _hoisted_12 = { class: "lang__link" }
const _hoisted_13 = {
  key: 1,
  class: "header__connect"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "Подключиться ", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.IMAGE_BASE_URL + 'logo.svg',
        alt: "Логотип"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("nav", {
      class: _normalizeClass(["header__nav nav", { 'nav--open': _ctx.isNavOpen }])
    }, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navArr, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "nav__item"
          }, [
            _createElementVNode("a", _hoisted_5, _toDisplayString(item), 1)
          ]))
        }), 128)),
        (!_ctx.store.isDesktop)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_9, [
          (!_ctx.store.isDesktop)
            ? (_openBlock(), _createElementBlock("button", _hoisted_10, " Вход "))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    (_ctx.store.isDesktop)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langs, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "lang__item"
            }, [
              _createElementVNode("a", _hoisted_12, _toDisplayString(item), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.store.isDesktop)
      ? (_openBlock(), _createElementBlock("button", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true),
    (!_ctx.store.isDesktop)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "header__open-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isNavOpen = !_ctx.isNavOpen)),
          style: _normalizeStyle(`background-image:url('${_ctx.IMAGE_BASE_URL}open.svg')`)
        }, null, 4))
      : _createCommentVNode("", true)
  ]))
}